import { Loader } from '@uswitch/comms-ui.loader'
import { Select as SparkSelect, Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '@uswitch/spark'
import React from 'react'

import Underlay from '~/components/underlay'
import { usePageContext } from '~/contexts/page-context'
import { transformProvidersForDropdown } from '~/utils/providers'

import * as st from './provider-dropdown-style'

export const ProviderDropdown = ({ providersData, providersUnderlay }) => {
  const providers = transformProvidersForDropdown(providersData)

  return (
    <Dropdown
      sx={st.currentProviderBox}
      className='spark-dropdown element-hidden'
      data-dropdown='provider-box'
      data-postcode-form-target='dropdown'
      data-cypress-id='provider-dropdown'
    >
      <div sx={st.dropdownMenuWrapper}>
        <DropdownMenu sx={st.dropdownMenu(providersUnderlay)} data-dropdown-element='menu'>
          {providers.map((section) => (
            <>
              {/* title section */}

              <DropdownItem sx={st.dropdownTitle}>
                <b>{section?.title || ''}</b>
              </DropdownItem>

              {/* options */}
              {section.providers.map((provider) => (
                <DropdownItem
                  className='fs-mask'
                  sx={st.dropdownItem}
                  data-value={provider.id}
                  data-action='click->postcode-form#dropdownSelect keydown->postcode-form#keydownDropdownSelect'
                >
                  {provider.name}
                </DropdownItem>
              ))}
            </>
          ))}
        </DropdownMenu>

        <div
          className='element-hidden'
          sx={st.providerSelectedLoading}
          data-postcode-form-target='providerSelectedLoading'
        >
          <Loader loading={true} customCSS={st.providerClickLoader}></Loader>
        </div>

        {providersUnderlay && <Underlay action='toggleDropdown' criticalJs />}
      </div>

      <DropdownButton as={Select} placeholder={'placeholder'} />
    </Dropdown>
  )
}

const Select = () => {
  const { scope } = usePageContext()

  return (
    <div
      data-dropdown-element='button'
      data-action='click->postcode-form#toggleDropdown keydown->postcode-form#keydownDropdownToggle'
    >
      <div sx={st.addressMatcherContainer}>
        <SparkSelect
          data-postcode-form-target='provider'
          data-scope={scope}
          sx={st.selectButton}
          placeholder='Select current provider'
        />
      </div>
    </div>
  )
}

export default ProviderDropdown
